import type {subscriptionTier} from '@features/db/schema';

export type SubscriptionTier = (typeof subscriptionTier.enumValues)[number];

/**
 * Gets the display name for a subscription tier.
 */
export function getTierDisplayName(
  tier: SubscriptionTier,
  isTeam: boolean,
): string {
  switch (tier) {
    case 'free':
      return isTeam ? 'Free Team' : 'Free';
    case 'plus':
      return isTeam ? 'Team Plus' : 'Plus';
    case 'pro':
      return isTeam ? 'Team Pro' : 'Pro';
  }
}
